import { getResource } from "./request";

export async function getFundsBudgetAnalytics() {
  const { response, error, code } = await getResource({
    endpoint: "analytics/GetBudget",
  });
  return { response, error, code };
}

export async function getChallengeBugetPerFunds(fundId: number) {
  const data = {
    fund_id: fundId,
  };

  const { response, error, code } = await getResource({
    endpoint: "analytics/GetBudget",
    data,
  });
  return { response, error, code };
}

export async function getProperty(data: PropertyAPIType) {
  const endpoint = "analytics/GetProperty";

  const { response, error, code } = await getResource({
    endpoint: endpoint,
    data: data,
  });
  return { response, error, code };
}

export async function getProposalRankings(
  filterProposalFrom: filterProposalFormType
) {
  const endpoint = "analytics/GetProposalRankings";

  const { response, error, code } = await getResource({
    endpoint: endpoint,
    data: filterProposalFrom,
  });
  return { response, error, code };
}

export async function getProposerRankings() {
  const endpoint = "analytics/GetProposerRankings";
  const data = { order_by: "MaxYesVotes" };

  const { response, error, code } = await getResource({
    endpoint: endpoint,
    data: data,
  });
  return { response, error, code };
}

export async function getCompletedCounts(
  chartData: completedCountFormDataType
) {
  const { response, error, code } = await getResource({
    endpoint: "analytics/GetCompletedCounts",
    data: chartData,
  });
  return { response, error, code };
}

export async function getFundAvailibilityPerChallenge(challenge_id: number) {
  const { response, error, code } = await getResource({
    endpoint: "analytics/GetFundAvailability",
    data: { challenge_id },
  });
  return { response, error, code };
}

export async function getProjectStatus(
  projectStatusForm: ProjectStatusFromType
) {
  const { response, error, code } = await getResource({
    endpoint: "analytics/GetProjectStatus",
    data: projectStatusForm,
  });

  return { response, error, code };
}

export async function getProperties(propertiesForm: PropertiesFormType) {
  const { response, error, code } = await getResource({
    endpoint: "analytics/GetProperties",
    data: propertiesForm,
  });
  return { response, error, code };
}

export async function getCompletionTimeROI() {
  const { response, error, code } = await getResource({
    endpoint: "analytics/GetCompletionTimeROI",
  });
  return { response, error, code };
}

export async function getProposerCorrelationMatrix(
  proposerCorrelationForm: ProposerCorrelationFormType
) {
  const { response, error, code } = await getResource({
    endpoint: "analytics/GetProposerCorrelationMatrix",
    data: proposerCorrelationForm,
  });
  return { response, error, code };
}

export async function getPowerIndex(form: PowerIndexAPIInputTypes) {
  const { response, error, code } = await getResource({
    endpoint: "analytics/BanzhafPI",
    data: form,
  });
  return { response, error, code };
}

export interface PowerIndexAPIInputTypes {
  quota: string;
  voter_weights: string;
}

export interface ProposerCorrelationFormType {
  merge_new_previous_proposers: string;
  include_correlation_colors: string;
}

export interface PropertiesFormType {
  property_names: string;
  status_grouping: string;
  include_decision_boundary: string;
  include_proposal_id: string;
  challenge_id: number | string | any[];
  probability_thresholds?: string;
  fund_id?: any[] | "All";
}

export interface ProjectStatusFromType {
  status_column: string;
  fund_id: number | string;
  amount_requested?: string;
  amount_distributed?: string;
  rating?: number;
}

export interface PropertyAPIType {
  property_name: "Amount" | "Rating" | "YesVotes" | "NoVotes" | "ResultVotes";
  aggregation_type?: "List" | "Max" | "Min" | "Avg" | "Count" | "Sum";
  status_grouping?: "None" | "Binary" | "Ternary";
  proposal_status?:
    | "Funded"
    | "Not Funded"
    | "Approved"
    | "Overbudget"
    | "Not Approved"
    | "Completed"
    | "Not Completed";
  fund_id?: string;
}

export interface FundingAmountsPerFund {
  value: Number[];
  fund_id: number;
  fund_name: string;
}

export interface FundsBudgetAnalytics {
  fund_id: number;
  fund_budget: number;
  fund_name: string;
}

export interface ChallengeAnalyticsData {
  challenge_id: number;
  challenge_amount: number;
  challenge_name: string;
  fund_id?: number;
  fund_name: string;
}

export interface chartLineData {
  fund_id: number;
  challenge_id: any;
  xAccumulateBy: string;
  yAccumulateQ: boolean;
}

export interface commonData {
  fund_id: number;
  challenge_id: number;
  fund_name: string;
  challenge_name: string;
}

export interface proposerRankingData {
  user_id: number;
  user_name: string;
  value: number;
}

export interface completedCounts {
  year: number;
  items: [];
}

export interface completedCountFormDataType {
  fund_id?: number | string | any[];
  challenge_id?: number | string | any[];
  xAccumulateBy: string;
  yAccumulateQ: string;
}

export interface filterProposalFormType {
  order_by: string;
  ordering: string;
}

export interface FundAvailibilityType {
  proposal_id: number;
  fund_availability: number;
  ranking: 1;
  amount_requested: number;
  proposal_name: string;
  fund_depletion: number;
  proposal_status: string;
}

export interface HomePageQuickStats {
  total_proposals: number;
  fund_budget: number;
  amount_requested: number;
  funded_proposals: number;
  funded_amount: number;
  no_of_funds: number;
  regular_challenges: number;
}
